import merge from 'merge';
import { createWebHistory, createRouter } from 'vue-router';
import mumbai from './../components/mumbai.vue';
import us from './../components/us.vue';
import report from './../components/report.vue';
import RegisterUser from './../components/RegisterUser.vue';
import CrsMumbai from './../components/CrsMumbai.vue';
import CrsUS from './../components/CrsUs.vue';
import CrsReport from './../components/Crsreport.vue';
import CrsRegisterUser from './../components/CrsRegisterUser.vue';
import Dashboard from './../components/Dashboard.vue';
import CRSDashboard from './../components/DashboardCRS.vue';
import FeedbackStatusCRS from './../components/FeedbackStatusCRS.vue';
import FeedbackStatus from './../components/FeedbackStatus.vue';
import RCA from './../components/RCA.vue';
// import store from '@/store'
import {
  UIM_MS_SSO_KEY,
  validateUser,
  redirectToCreditLogin,
  validatePath
} from '@/apis/userauthentication';
import NProgress from 'nprogress'
const routes = [
  {name:'mumbai', path: '/feed-back', component: mumbai  },
  { path: '/', redirect: {name : 'mumbai'} },
  { path: '/usfeedbackform', component: us },
  { path: '/report', component: report },
  { path: '/RegisterUser', component: RegisterUser },
  { path: '/dashboard', component: Dashboard},
  { name :'CrsMumbai',path: '/CRS/mumbai', component: CrsMumbai , meta : {requireCrs :true} },
  { path: '/CRS/', component: CrsMumbai , meta : {requireCrs :true} },
  { path: '/CRS/usfeedbackform', component: CrsUS , meta : {requireCrs :true}},
  { path: '/CRS/report', component: CrsReport  , meta : {requireCrs :true} },
  { path: '/CRS/RegisterUser', component: CrsRegisterUser , meta : {requireCrs :true}},
  { path: '/CRS/dashboard', component: CRSDashboard , meta : {requireCrs :true} },
  { path: '/CRS/feedbackStatus', component: FeedbackStatusCRS , meta : {requireCrs :true} },
  { path: '/feedbackStatus', component: FeedbackStatus , meta : {requireCrs :true} },
  { path: '/RCA', component: RCA },

];


const authCacheMillis = 60000;
var authCheckTime = 0;
const router = createRouter({
  history: createWebHistory(),
  routes
});
export function doesRouteRequireAuth(matched) {
  // we assume all routes require auth unless explicity set to false
  return !matched.some(
    route => route.meta && route.meta.requiresAuth === false
  );
}
export function validateRouteUserFeatures(
  routeUserFeatures = {},
  userFeatures = {}
) {
  // collect any route userFeatures set to true
  const permissionKeys = Object.keys(routeUserFeatures).filter(
    key => routeUserFeatures[key] === true
  );

  // cross reference against userFeatures
  return permissionKeys.every(key => userFeatures[key] === true);
}


router.afterEach(() => {
  NProgress.done()
});

router.beforeEach((to, from, next) => {

  NProgress.start();
  const routeRequiresAuth = doesRouteRequireAuth(to.matched);
  const tokenId = to.query[UIM_MS_SSO_KEY];
  
  if (tokenId) {
      const currentUrl = new URL(window.location.href);
      // strip the token from the url to prevent it from being bookmarked
      currentUrl.searchParams.delete(UIM_MS_SSO_KEY);
  
      const newTo = merge({}, to, {
        fullPath: `${to.path}${currentUrl.search}`
      });
  
      // strip the token from the new route to prevent it from being bookmarked
      delete newTo.query[UIM_MS_SSO_KEY];
  
      // redirect the user to their intended route
      // the route guard will then validate the cookie
      router.replace(newTo);
      
      next(false);
    } else if (routeRequiresAuth) {
      
              let currentUrl = new URL(window.location.href);
             
              var responseData;
              validateUser().then(response => {
                if (response != "" && response != undefined && response != null) {
                  responseData = response.data[0];
                  if(responseData.group_name !=='CRS') {
                    responseData.group_name ='NON_CRS'
                  }
                  if (Date.now() - authCheckTime <= authCacheMillis) {
                    next();
                  } 
                  else {
                    authCheckTime = Date.now();
                    if (responseData != "" && responseData != undefined && responseData != null) {
                      if (responseData.user_role != "" && responseData.user_role != undefined && responseData.user_role != null) {
                        
                        if (responseData.group_name == 'CRS' )
                          {
                          let path = window.location.pathname;
                          if(!path.includes('/CRS') ) {
                            path = '/CRS'+ path
                          }
                          if (validatePath(responseData.user_role, path,responseData.group_name)) {
                            if(path.includes('/CRS/usfeedbackform')) {
                            next ()
                            }
                            else {
                              next(path)
                            }
                              
                          }
                          else {
                            alert("You do not have necessary permission to access this page");
                              if ( responseData.user_role =='restricted admin internal' )
                              {
                                const reportUrl = new URL(process.env.VUE_APP_UI +'CRS/');
                                window.location.href  = reportUrl;
                              }
                              else if (responseData.user_role =='restricted admin external') {
                                const reportUrl = new URL(process.env.VUE_APP_UI +'CRS/report');
                                window.location.href  = reportUrl;
                              }
                              else {
                                window.location.href  = from.fullPath;
                              NProgress.done()
                              }
                          }
                          } 
                        else
                        {
                          if (validatePath(responseData.user_role, currentUrl.pathname,responseData.group_name)) {
                            next();
                          }
                          else {
                              alert("You do not have necessary permission to access this page");
                              if ( responseData.user_role =='restricted admin external')
                              {
                                const reportUrl = new URL(process.env.VUE_APP_UI +'report');
                                window.location.href  = reportUrl;
                              } else if ( responseData.user_role =='restricted admin internal')
                              {
                                const reportUrl = new URL(process.env.VUE_APP_UI );
                                window.location.href  = reportUrl;
                              }
                              else {
                                window.location.href  = from.fullPath;
                              NProgress.done()
                              }
                            
                            
    
                          }
                        }
                      }
                      else {
                        console.log("in responseData.user_role!= else");
                        redirectToCreditLogin();
                        next(false);
                      }
                    }
                    else {
                      console.log("in responseData!= else");
                       redirectToCreditLogin();
                      next(false);
                    }
                  }
                }
                else {
                  console.log("response!='' else");
                  redirectToCreditLogin();
                  next(false);
                }
              });
        }
    });        
export default router;


